import { AztecAddress } from "@aztec/aztec.js";
import { Button, Modal, ModalBody, ModalContent, ModalHeader } from "@heroui/react";
import { BadgeCheckIcon, ChevronLeftIcon, IdCardIcon } from "lucide-react";
import { shortHex } from "../../utils";
import { TransactionTypeChip } from "../bridge/TransactionTypeChip";
import { TransferCard } from "./TransferCard";
import type { TransferFormData } from "./transfersConfig";

export function PrivateTransferReviewModal({
  onClose,
  transferFormData,
  onTransfer,
  onBack,
}: {
  onClose: () => void;
  transferFormData: TransferFormData;
  onTransfer: () => void;
  onBack: () => void;
}) {
  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalHeader>
          <div className="flex items-center">
            <Button isIconOnly onPress={onBack} className="bg-transparent -ml-3">
              <ChevronLeftIcon className="text-[#ADC0D0]" />
            </Button>
            <p className="text-lg font-semibold">Confirm Transfer</p>
          </div>
        </ModalHeader>

        <ModalBody className="flex flex-col gap-4">
          <TransferCard
            tokenSymbol={transferFormData.tokenSymbol}
            displayAmount={Number(transferFormData.amount)}
            senderAddress={transferFormData.l2AccountAddress.toString()}
            recipientAddress={transferFormData.recipientAddress.toString()}
          />

          <div className="flex items-center gap-2 p-4 bg-[#3F6784] rounded-xl hover:bg-[#3F6784]/50 transition-colors w-full text-left text-sm">
            <IdCardIcon className="text-[#14DBC0] stroke-1.5 size-6 m-2" />

            <div className="flex-1">
              <div className="text-[#ADC0D0]">ID Verification</div>
              <div className="font-semibold">{shortHex(AztecAddress.random().toString())}</div>
            </div>

            <div className="inline-flex items-center gap-1">
              <BadgeCheckIcon className="size-6 text-green-500/90 fill-green-500/10 " />
              <span className="text-green-500 font-semibold">Verified</span>
            </div>
          </div>

          <div className="w-full space-y-3 text-sm">
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Transaction type</div>
              <TransactionTypeChip type={transferFormData.transferMode} />
            </div>
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Transfer method</div>
              <div className="font-semibold">ID Verification</div>
            </div>
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Est. Time</div>
              <div className="font-semibold">~15 min</div>
            </div>
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Gas fees</div>
              <div className="font-semibold">0.00005 ETH</div>
            </div>
          </div>

          <Button
            fullWidth
            radius="full"
            size="lg"
            color="primary"
            className="font-semibold text-large h-16"
            onPress={onTransfer}
          >
            Transfer
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
